// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "price-37z-y";
var _3 = "price_selected-1kYEu";
var _4 = "price__money-bRhYz";
var _5 = "prices__wrp-3Wjx8";
var _6 = "selectFrom_best-1rfvC";
var _7 = "fare_family-1qP-L";
var _8 = "best-21Nn8";
var _9 = "button-Gy5-B";
export { _1 as "__esModule", _2 as "price", _3 as "price_selected", _4 as "price__money", _5 as "prices__wrp", _6 as "selectFrom_best", _7 as "fare_family", _8 as "best", _9 as "button" }
export default { "__esModule": _1, "price": _2, "price_selected": _3, "price__money": _4, "prices__wrp": _5, "selectFrom_best": _6, "fare_family": _7, "best": _8, "button": _9 }
